import React, { useState } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import EyeSVG from '../svg/EyeSVG'
import EyeClosedSVG from '../svg/EyeClosedSVG'

const FormInput = ({
  label,
  name,
  type,
  placeholder,
  register,
  validationRules,
  errors,
  required = false,
  withPasswordToggle = false,
  onForgotPassword,
  testId,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)
  // `auth` is loaded by both apps (portal and LeaRes): this file is shared.
  const { t } = useTranslation('auth')

  return (
    // relative: anchors the absolute error <p> below to THIS field, otherwise it
    // resolves against a far ancestor and lands over the next field.
    <div className="pb-3 relative">
      {label && (
        <label className="text-sm taller:text-base" htmlFor={name}>
          {label}
          {required && <span className="text-red"> *</span>}
        </label>
      )}
      <div className="relative">
        <input
          id={name}
          data-testid={testId}
          className={clsx(
            'w-full h-[34px] taller:h-[40px] mt-px text-sm taller:text-base font-light border-2 rounded-xl outline-none placeholder:text-opacity-70',
            {
              'bg-blue bg-opacity-30 border-blue focus:border-pale-blue':
                !errors[name],
              'bg-red/10 border-red': errors[name],
              'pl-2 pr-9 desktop:pr-10': withPasswordToggle,
              'px-2': !withPasswordToggle,
              'sentry-mask': type === 'password',
            }
          )}
          type={
            withPasswordToggle
              ? isPasswordVisible
                ? 'text'
                : 'password'
              : type
          }
          placeholder={placeholder}
          autoComplete={
            type === 'password'
              ? 'current-password'
              : type === 'email'
                ? 'email'
                : 'off'
          }
          {...register(name, validationRules)}
        />
        {withPasswordToggle && (
          <button
            type="button"
            className={clsx('absolute right-3 translate-y-[-50%]', {
              'top-[calc(50%+0.5px)]': isPasswordVisible,
              'top-[calc(50%+1px)]': !isPasswordVisible,
            })}
            onClick={() => setIsPasswordVisible((prev) => !prev)}
          >
            {isPasswordVisible ? (
              <EyeSVG isWhite={true} />
            ) : (
              <EyeClosedSVG isWhite={true} />
            )}
          </button>
        )}
      </div>
      {errors[name] && (
        <p className="absolute text-red text-xs">{errors[name].message}</p>
      )}
      {onForgotPassword && (
        <div className="flex items-center justify-end w-full text-xs taller:text-sm">
          <button
            type="button"
            className="text-white text-opacity-70 hover:text-opacity-100 transition font-light py-1 rounded"
            onClick={onForgotPassword}
          >
            {t('formInput.forgotPassword')}
          </button>
        </div>
      )}
    </div>
  )
}

export default FormInput
